import React from 'react';
import { DPI } from '../../config/dtfConfig';
import { Button } from '@mui/material';

const UploadArrowIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 64 64"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M26 48h12V28h14L32 6 12 28h14v20z" />
    <rect x="10" y="52" width="44" height="6" rx="3" ry="3" />
  </svg>
);

export default function UploadButton({ onUpload }) {
  return (
    <Button
      component="label"
      variant="contained"
      startIcon={<UploadArrowIcon />}
      sx={{
        mb:1,
        backgroundColor: '#94C940',
        color: 'white',
        borderRadius: '8px',
        px: 3,
        py: 0,
        fontWeight: '1000',
        fontFamily: 'Anek Latin',
        fontSize: '1.4rem',
        textTransform: 'uppercase',
        '&:hover': {
          backgroundColor: '#94C940',
        }
      }}
    >
      Upload
      <input
        type="file"
        hidden
        accept="image/*"
        multiple
        onChange={(e) => {
          const files = Array.from(e.target.files);
          const newImages = [];
          let croppedCount = 0;

          const trimTransparentBorder = (imgEl, alphaThreshold = 10) => {
            try {
              const w = imgEl.naturalWidth || imgEl.width;
              const h = imgEl.naturalHeight || imgEl.height;
              if (!w || !h) return { changed: false };
              const c = document.createElement('canvas'); c.width = w; c.height = h;
              const x = c.getContext('2d'); x.drawImage(imgEl, 0, 0);
              const { data } = x.getImageData(0, 0, w, h);
              let top = 0, left = 0, right = w - 1, bottom = h - 1;
              const isOpaqueAt = (px) => data[px + 3] > alphaThreshold;
              for (; top <= bottom; top++) { let f=false; const row=top*w*4; for (let col=0; col<w; col++){ if(isOpaqueAt(row+col*4)){ f=true; break;} } if(f) break; }
              for (; bottom >= top; bottom--) { let f=false; const row=bottom*w*4; for (let col=0; col<w; col++){ if(isOpaqueAt(row+col*4)){ f=true; break;} } if(f) break; }
              for (; left <= right; left++) { let f=false; for(let row=top; row<=bottom; row++){ const px=row*w*4+left*4; if(isOpaqueAt(px)){ f=true; break; } } if(f) break; }
              for (; right >= left; right--) { let f=false; for(let row=top; row<=bottom; row++){ const px=row*w*4+right*4; if(isOpaqueAt(px)){ f=true; break; } } if(f) break; }
              const cropW = Math.max(0, right-left+1); const cropH = Math.max(0, bottom-top+1);
              if (cropW <= 0 || cropH <= 0 || (cropW === w && cropH === h)) return { changed: false };
              const out = document.createElement('canvas'); out.width = cropW; out.height = cropH;
              out.getContext('2d').drawImage(c, left, top, cropW, cropH, 0, 0, cropW, cropH);
              return { changed: true, canvas: out };
            } catch (e) { return { changed: false }; }
          };

          files.forEach(file => {
            const reader = new FileReader();
            reader.onload = () => {
              const img = new Image();
              img.onload = () => {
                // Trim transparency if present
                const t = trimTransparentBorder(img, 10);
                let srcData = reader.result;
                let pxW = img.width, pxH = img.height;
                if (t.changed && t.canvas) {
                  try { srcData = t.canvas.toDataURL('image/png'); croppedCount++; pxW = t.canvas.width; pxH = t.canvas.height; }
                  catch (_) { /* keep original */ }
                }
                const newImage = {
                  src: srcData,
                  image: img,
                  quantity: 1,
                  widthIn: pxW / DPI,
                  heightIn: pxH / DPI,
                  scale: 1,
                  lockAspectRatio: true,
                };
                newImages.push(newImage);
                if (newImages.length === files.length) {
                  onUpload(newImages);
                  if (croppedCount > 0) {
                    // Fire-and-forget toast using a custom event; ImageArranger listens and shows a toast if desired
                    document.dispatchEvent(new CustomEvent('sodtf-crop-toast', { detail: { count: croppedCount } }));
                  }
                }
              };
              img.src = reader.result;
            };
            reader.readAsDataURL(file);
          });
        }}
      />
    </Button>
  );
}
